import { motion } from "framer-motion";
import { Check, Clock } from "lucide-react";
import { useLang } from "../i18n";
import { SERVICES } from "../siteData";

export function Services({ onSelect }) {
    const { lang, t } = useLang();
    return (
        <section id="services" className="relative mx-auto max-w-7xl px-4 py-28 sm:px-6" data-testid="services-section">
            <motion.div
                initial={{ opacity: 0, y: 36 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7 }}
            >
                <p className="font-mono2 text-xs uppercase tracking-[0.25em] text-[#FFB800]">{t.services.overline}</p>
                <h2 className="mt-3 font-display text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">
                    {t.services.title}
                </h2>
                <p className="mt-3 max-w-xl text-[#8E8EA0]">{t.services.sub}</p>
            </motion.div>

            <div className="mt-12 grid gap-5 sm:grid-cols-2 xl:grid-cols-4">
                {SERVICES.map((s, i) => (
                    <motion.div
                        key={s.id}
                        data-testid="service-item-card"
                        initial={{ opacity: 0, y: 36 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.6, delay: i * 0.08 }}
                        className={`group flex flex-col rounded-3xl border p-7 transition-all duration-300 hover:-translate-y-1.5 ${
                            s.featured
                                ? "border-[#FFB800]/40 bg-gradient-to-b from-[#181824] to-[#131108] glow-amber"
                                : "border-white/10 bg-[#13131A] hover:border-[#FFB800]/40"
                        }`}
                    >
                        <div className="flex items-baseline justify-between">
                            <p className="font-mono2 text-3xl font-bold text-[#FFB800]">
                                A${s.price}
                                <span className="ml-1 text-xs text-[#8E8EA0]">{lang === "zh" ? s.suffix_zh : s.suffix_en}</span>
                            </p>
                            <span className="inline-flex items-center gap-1.5 rounded-full border border-white/10 px-2.5 py-1 font-mono2 text-[10px] text-[#8E8EA0]">
                                <Clock size={11} />
                                {lang === "zh" ? s.duration_zh : s.duration_en}
                            </span>
                        </div>
                        <h3 className="mt-4 font-display text-xl font-semibold">{lang === "zh" ? s.name_zh : s.name_en}</h3>
                        <p className="mt-2 text-sm leading-relaxed text-[#8E8EA0]">{lang === "zh" ? s.desc_zh : s.desc_en}</p>
                        <ul className="mt-5 flex-1 space-y-2.5">
                            {(lang === "zh" ? s.features_zh : s.features_en).map((f) => (
                                <li key={f} className="flex items-center gap-2 text-sm text-[#c9c9d4]">
                                    <Check size={14} className="text-[#FFB800]" />
                                    {f}
                                </li>
                            ))}
                        </ul>
                        <button
                            data-testid="service-select-btn"
                            onClick={() => onSelect(s.id)}
                            className="mt-7 w-full rounded-full border border-[#FFB800]/50 py-2.5 text-sm font-semibold text-[#FFB800] transition-colors duration-300 group-hover:bg-[#FFB800] group-hover:text-[#0B0B0E]"
                        >
                            {t.services.select} →
                        </button>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
